import Vue from 'vue'
import VueRouter from 'vue-router'
import { addRecord } from '@/api/record'
import { EventBus } from '@/eventBus';

Vue.use(VueRouter)

const routes = [
    {
        path:'/',
        redirect:'/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/IndexView.vue')
    },
    {
        path: '/product',
        name: 'product',
        component: () => import('../views/ProductView.vue'),
    },
    {
        path: '/product/productId/:productId',
        name: 'productDetails',
        component: () => import("../views/ProductDetailsView.vue")
    },
    {
        path: '/example',
        name: 'example',
        component: () => import('../views/ExampleView.vue')
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('../views/NewsView.vue')
    },
    {
        path: '/news/list',
        name: 'newsList',
        component: () => import('../views/NewsListView.vue')
    },
    {
        path: '/news/detail',
        name: 'newsDetails',
        component: () => import('../views/NewsDetailsView.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/AboutView.vue')
    },
    {
        path: '/joinus',
        name: 'joinus',
        component: () => import('../views/JoinView.vue')
    }
]

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    if (JSON.stringify(to.query) === '{}' && to.fullPath != '/index' && to.fullPath != '/news/list') {
        return;
    }
    let originUrl = '';
    if (from.path === '/' && from.matched && from.matched.length === 0) {
        let visitFlag =  sessionStorage.getItem('visitFlag');
        if (!visitFlag) {
            if (document.referrer) {
                originUrl = document.referrer;
            } else {
                originUrl = '直接访问';
            }
            const params = {
                navigationId: to.query.navigationId ? to.query.navigationId : '1',
                originUrl: originUrl,
                actionType: '0',
                path: to.path
            }
            addRecord(params);
            sessionStorage.setItem('visitFlag', 1);
        }
    } else {
        originUrl = '内部访问';
        const params = {
            navigationId: to.query.navigationId ? to.query.navigationId : '1',
            originUrl: originUrl,
            actionType: '0',
            path: to.path
        }
        addRecord(params);
    }
    window.scrollTo(0, 0);
    EventBus.$emit('showHeader', {});
    next();
});

export default router
